// extracted by mini-css-extract-plugin
export default {"component":"WidgetRepeatPeriod_component__MDd2o","list":"WidgetRepeatPeriod_list__A4JO5","titleContainer":"WidgetRepeatPeriod_titleContainer__7uG5r"};